module.exports = __webpack_public_path__ + "img/btn-batdaulambai.e92acc6b.png";